<template>
  <div>
    <div @click="visible = true">
      <slot />
    </div>

    <a-modal
      title="选择固定资产"
      :visible="visible"
      @cancel="cancel"
      :footer="null"
      width="1500px"
    >
      <a-input-search
        style="margin-bottom: 16px"
        placeholder="请输入资产编码进行查询"
        enter-button
        v-model="search"
        @search="onSearch"
      ></a-input-search>

      <a-table
        :indentSize="0"
        bordered
        :data-source="list"
        :loading="loading"
        @change="onChange"
        :row-selection="{
          selectedRowKeys,
          onChange: onSelectChange,
        }"
        :pagination="{
          total,
          current,
          pageSize,
          showTotal: (total) => `共 ${total} 条记录`,
        }"
        rowKey="id"
      >
        <a-table-column title="资产编码" data-index="assetCode"> </a-table-column>
        <a-table-column title="资产类别">
          <template slot-scope="text">
            <div style="display: flex; align-items: center">
              <DataDictFinder
                dictType="fixed_asset_type"
                :dictValue="text.category.categoryCode"
              />-
              {{ text.category.subCategoryName }}
            </div>
          </template>
        </a-table-column>
        <a-table-column title="品牌型号" data-index="brandModel"> </a-table-column>
        <a-table-column title="财务编码" data-index="financialCode"> </a-table-column>
        <a-table-column title="启用日期" data-index="startTime"> </a-table-column>
        <a-table-column title="原值" data-index="purchasePrice"> </a-table-column>
        <a-table-column title="净残值率" data-index="netSalvageRate"></a-table-column>
        <a-table-column title="残值" data-index="netAmount"></a-table-column>
      </a-table>
      <div style="display: flex; justify-content: flex-end">
        <a-button type="primary" @click="handleSubmit" style="margin-right: 16px"> 选择 </a-button>
        <a-button @click="cancel">取消</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import moment from "moment";
import request from "@/api/request";
function fetchList(data) {
  return request({
    url: "/office-service/fixed-asset/page",
    data,
    method: "post",
  });
}
export default {
  data() {
    return {
      visible: false,
      loading: false,
      current: 1,
      pageSize: 10,
      list: [],
      total: 0,
      search: "",
      selectedRowKeys: [],
    };
  },

  watch: {
    visible(newValue) {
      if (newValue) {
        this.selectedRowKeys = [];
        if (this.list.length === 0) {
          this.getList();
        }
      }
    },
  },

  methods: {
    onSelectChange(keys) {
      this.selectedRowKeys = keys;
    },
    getList() {
      const { current, pageSize, form } = this;

      this.loading = true;
      fetchList({
        pageNum: current,
        pageSize,
        assetCode: this.search,
        status: "fixed_asset_status_to_be_scrapped"
      })
        .then((res) => {
          this.loading = false;
          if (Array.isArray(res.list)) {
            this.list = res.list;
            this.total = res.totalSize;
            this.list.forEach((record) => {
              const date = moment(record.startTime);
              let startTime = null;
              // 判断是否是当月的第一天（即日期为1号）
              if (date.date() === 1) {
                // 是当月第一天，返回当天（当月第一天）
                startTime = date.startOf('month').format('YYYY-MM-DD')
              } else {
                // 不是当月第一天，返回下个月第一天
                startTime = date.add(1, 'month').startOf('month').format('YYYY-MM-DD')
              }
              record.useMonth = moment().diff(moment(startTime), "months") + 1;
              let rato = record.useMonth / record.scrapLimitMonths
              if(rato > 1){
                rato = 1
              }
              record.depreciationPrice = record.purchasePrice * (1 - record.netSalvageRate) * rato;
              record.depreciationPrice = record.depreciationPrice.toFixed(2);
              record.depreciationPrice = parseFloat(record.depreciationPrice);
              record.netAmount = (record.purchasePrice - record.depreciationPrice).toFixed(2);
              record.netAmount = parseFloat(record.netAmount);
            })
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onChange(pagination) {
      this.current = pagination.current;
      this.pageSize = pagination.pageSize;
      this.getList();
    },

    onSearch() {
      this.current = 1;
      this.getList();
    },
    handleSubmit() {
      const records = this.selectedRowKeys.map((key) =>
        this.list.find((item) => item.id === key)
      );
      console.log(records);
      this.$emit("change", records);
      this.visible = false;
    },
    cancel() {
      this.visible = false;
      this.$emit("cancel");
    },
  },
};
</script>
